<template>
  <label :for="labelFor" class="label column is-3 is-flex">
    <span>{{ title }}</span>
    <div class="is-relative tooltip-container" v-if="hasTooltip">
      <i class="material-icons">&#xE88F;</i>
      <div class="tooltip" :class="tooltipPlacement" role="tooltip">
        <div class="tooltip-outer">
          <div class="tooltip-arrow"></div>
          <div class="tooltip-inner">
            {{ tooltipText }}
          </div>
        </div>
      </div>
    </div>
  </label>
</template>

<script>
import Api from 'services/Api';
import { mapState } from 'vuex';
import * as moment from 'moment';

export default {
  name: 'FormLabel',
  props: {
    title: {
      type: String,
    },
    labelFor: {
      type: String,
      default: '',
    },
    hasTooltip: {
      type: Boolean,
      default: false,
    },
    tooltipText: {
      type: String,
      default: '',
    },
    tooltipPlacement: {
      type: String,
      default: 'tooltip-top',
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~scss/utilities/initial-variables.scss';
@import '~scss/utilities/derived-variables.scss';

.label {
  font-weight: normal;
  margin: 0;

  .tooltip-container {
    width: auto;
    .material-icons {
      font-size: 0.75rem;
      margin: 0 0.5rem;
    }
  }

  .tooltip {
    width: 15rem;
  }
}
</style>

<style lang="scss">
.is-relative {
  position: relative;
}
</style>
